import {
  hideCurrentLiveAgentButton,
  isLiveAgentChatOpen,
  showLiveAgentChat
} from './liveAgentChat';
import { getQuriobotID } from '../../../utils/quriobot/quriobot_config';

let SCRIPT_CREATED = false;
let WIDGET_SHOW = false;
let WIDGET_INITIALIZED = false;

let LIVE_AGENT_MODE = false;

let lastRequestedParams = {
  isAuthenticated: false,
  displayWidget: false,
  language: null,
  firstName: null,
  lastName: null,
  email: null,
  caseId: null
};

let lastOpenParams = {
  isAuthenticated: false,
  displayWidget: false,
  language: null,
  firstName: null,
  lastName: null,
  email: null,
  caseId: null
};

export const showChatBot = (
  isAuthenticated,
  displayWidget,
  language,
  firstName,
  lastName,
  email,
  caseId
) => {
  lastRequestedParams = {
    isAuthenticated,
    displayWidget,
    language,
    firstName,
    lastName,
    email,
    caseId
  };

  mainLoop();
};

const mainLoop = () => {
  if (lastRequestedParams.displayWidget || LIVE_AGENT_MODE) {
    if (!isLiveAgentChatOpen()) {
      createScript();
      updateBotIfNeeded();
    }
  } else {
    tryToRemoveWidget();
  }
};

export const chatBotReturnFromLiveAgentChat = () => {
  LIVE_AGENT_MODE = false;
  mainLoop();
};

// decision key says to remove (example logged out)
const tryToRemoveWidget = () => {
  // only can remove if it is attached
  if (!WIDGET_SHOW) {
    return;
  }
  // when talking to live agent block removing
  if (LIVE_AGENT_MODE) {
    return;
  }
  // remove only if it exists
  if (!!window.quriobot) {
    WIDGET_SHOW = false;
    WIDGET_INITIALIZED = false;
    window.quriobot.destroy();
  }
};

const updateBotIfNeeded = () => {
  if (LIVE_AGENT_MODE) {
    if (WIDGET_SHOW) {
      WIDGET_SHOW = false;
      WIDGET_INITIALIZED = false;
      window.quriobot.destroy();
    }

    return;
  }
  // was destroyed at some point
  if (!WIDGET_SHOW) {
    restartBot();
    WIDGET_SHOW = true;
  } else {
    if (!WIDGET_INITIALIZED) {
      return;
    }
    // check if is chatting and did not log-in/out
    if (
      window.quriobot.isOpen &&
      lastOpenParams.isAuthenticated === lastRequestedParams.isAuthenticated
    ) {
      return;
    }

    // bot "should not" be open now
    // check if language or authentication has changed since last check
    if (paramsChanged()) {
      WIDGET_INITIALIZED = false;
      window.quriobot.destroy();
      restartBot();
    }
  }
};

const paramsChanged = () => {
  return (
    lastOpenParams.language !== lastRequestedParams.language ||
    lastOpenParams.isAuthenticated !== lastRequestedParams.isAuthenticated ||
    lastOpenParams.firstName !== lastRequestedParams.firstName ||
    lastOpenParams.lastName !== lastRequestedParams.lastName ||
    lastOpenParams.caseId !== lastRequestedParams.caseId
  );
};

const restartBot = () => {
  window.qbOptions[0].use = getQuriobotID(lastRequestedParams.isAuthenticated);
  window.qbOptions[0].language = lastRequestedParams.language;
  window.qbOptions[0].visitor = createVisitor();
  window.qbOptions[0].context = createCaseIdContext();
  lastOpenParams = { ...lastRequestedParams };

  hideCurrentLiveAgentButton();
  window.quriobot.init();
};

const createScript = () => {
  if (SCRIPT_CREATED) {
    return;
  }
  SCRIPT_CREATED = true;

  if (!Array.isArray(window.qbOptions)) {
    window.qbOptions = [];
  }

  window.switchToLiveChat = (firstName, lastName, caseId, email) => {
    LIVE_AGENT_MODE = true;
    if (WIDGET_SHOW) {
      WIDGET_SHOW = false;
      WIDGET_INITIALIZED = false;
      window.quriobot.destroy();
    }
    showLiveAgentChat(
      false,
      lastOpenParams.isAuthenticated,
      lastOpenParams.language,
      !!email ? email : lastOpenParams.email,
      !!firstName ? firstName : lastOpenParams.firstName,
      !!lastName ? lastName : lastOpenParams.lastName,
      !!caseId ? caseId : lastOpenParams.caseId
    );
  };

  lastOpenParams = { ...lastRequestedParams };

  window.qbOptions.push({
    baseUrl: 'https://botsrv2.com',
    use: getQuriobotID(lastRequestedParams.isAuthenticated),
    language: lastRequestedParams.language,
    visitor: createVisitor(),
    context: createCaseIdContext(),
    // 1) choose no help needed, bot will close
    // 2) choose no additional info needed
    // 3) exit from final conversation step
    onFinish: () => {
      setTimeout(() => {
        mainLoop();
      }, 1100);
    },
    // minimize chat from X
    onLeave: () => {
      mainLoop();
    },
    onInit: () => {
      WIDGET_INITIALIZED = true;
      WIDGET_SHOW = true;
      mainLoop();
    }
  });

  hideCurrentLiveAgentButton();
  WIDGET_SHOW = true;

  let script = document.createElement('script');
  script.src = 'https://static.botsrv2.com/website/js/widget2.980a8167.js';
  script.crossOrigin = 'anonymous';
  script.defer = true;

  const lastScript = document.scripts[document.scripts.length - 1];
  lastScript.parentElement.insertBefore(script, lastScript.nextSibling);
};

const createCaseIdContext = () => {
  let context = {};
  if (lastRequestedParams.caseId) {
    context = { caseId: lastRequestedParams.caseId };
  }
  return context;
};

const createVisitor = () => {
  let visitor;
  if (
    lastRequestedParams.firstName ||
    lastRequestedParams.lastName ||
    lastRequestedParams.email
  ) {
    visitor = {
      firstName: lastRequestedParams.firstName,
      lastName: lastRequestedParams.lastName,
      email: lastRequestedParams.email
    };
  }
  return visitor;
};
